import classNames from "classnames";
import * as React from "react";

import style from "components/export/export-file-dialog.scss";
import Export from "components/icons/Export";
import buttons from "styles/buttons.scss";
import { useTheme } from "utils/useTheme";

import testIds from "testIds.json";

interface Props {
    introductionMessage?: string;
    downloadMessage: string;
    onDownloadClicked: () => void;
}

const ExportFileView = (props: Props) => {
    const theme = useTheme();
    return (
        <div className={style.exportFileWrapper}>
            {props.introductionMessage && <div className={style.introductionLabel}>{props.introductionMessage}</div>}

            <div className={style.export}>
                <Export color={theme.iconFillColor} />
                <div>
                    <button
                        onClick={props.onDownloadClicked}
                        className={classNames(style.lowerCaseOr, buttons.textButton, buttons.buttonWithoutIcon)}
                        data-testid={testIds.common.exportFileDialog.downloadButton}
                    >
                        {props.downloadMessage}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExportFileView;
